export default {
    install(Vue)  {
        Vue.prototype.$showMaskVideo = function(videoSrc) {
            let _this = this;
            _this.$store.state.maskVideo = true;
            _this.$store.state.playerOptions.sources[0].src = videoSrc;
        };
    }
}
